export default __webpack_public_path__ + "static/media/cultivo.4a9da9b3.png";